import { LoadUserAdminOrganizationsResult } from '@ffncc/common';
import { loadUserAdminOrganizations } from './contracts/user.service.contract';

export class UserService {
    static async loadUserAdminOrganizations(): Promise<LoadUserAdminOrganizationsResult> {
        return loadUserAdminOrganizations({});
    }
}
